import React, { useState } from 'react';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DataObjectIcon from '@mui/icons-material/DataObject';

import { MonitoringBonLivraison } from 'types/monitoringBonsLivraison';
import JsonViewerDialog from 'components/Shared/JsonViewerDialog/JsonViewerDialog';
import GeswebLink from 'components/Shared/GeswebLink';

const formatDate = (iso: string | null): string => {
    if (!iso) return '—';
    const d = new Date(iso);
    return d.toLocaleString('fr-FR');
};

// Libellés des statuts BonLivraisonGestionStatut (aligné sur l'enum C#).
const STATUT_LIBELLES: Record<number, string> = {
    0: 'Généré',
    1: 'Édité',
    2: 'Demande annulation',
    3: 'Annulé',
    4: 'Préparé',
    5: 'Contrôle en cours',
    6: 'Attente expédition',
    7: 'Expédié',
    8: 'Mise à quai',
    9: 'Réparti sur camion',
    10: 'Mise en camion',
    11: 'Fin de préparation',
    12: 'Livré',
    13: 'Retrait effectué',
    14: 'Ordonnancement',
    15: 'Disponible magasin',
};

const statutLibelle = (statut: number | null): string => {
    if (statut === null || statut === undefined) return '—';
    return STATUT_LIBELLES[statut] ?? String(statut);
};

// Ligne du tableau des BL orphelins (avec dialog JSON dédié).
function MonitoringBonLivraisonRow({ bl }: { bl: MonitoringBonLivraison }) {
    const [jsonOpen, setJsonOpen] = useState(false);

    return (
        <TableRow hover sx={{ height: 53 }}>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>
                <GeswebLink mode="button" label={bl.cle} structure="bonlivraison" cle={bl.cle} />
            </TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>{bl.numeroPiece}</TableCell>
            <TableCell>{statutLibelle(bl.statut)}</TableCell>
            <TableCell>{bl.codeDepotDepart ?? '—'}</TableCell>
            <TableCell sx={{ whiteSpace: 'nowrap' }}>{formatDate(bl.dateIntegration)}</TableCell>
            <TableCell align="right">
                <Tooltip title="Voir le message JSON">
                    <span>
                        <IconButton size="small" onClick={() => setJsonOpen(true)} disabled={!bl.messageJson}>
                            <DataObjectIcon fontSize="small" />
                        </IconButton>
                    </span>
                </Tooltip>
                <JsonViewerDialog
                    open={jsonOpen}
                    onClose={() => setJsonOpen(false)}
                    title={`Message JSON — ${bl.cle}`}
                    jsonEntries={[{ label: bl.cle, value: bl.messageJson, dateIntegration: bl.dateIntegration }]}
                />
            </TableCell>
        </TableRow>
    );
}

export default MonitoringBonLivraisonRow;
